// extracted by mini-css-extract-plugin
export default {"item":"MenuItem_item__II9qu","image":"MenuItem_image__grgM-"};